module.exports = __webpack_public_path__ + "img/logo-header.3037f22a.png";